import history from '../history';
import auth0 from 'auth0-js';
import { AUTH_CONFIG } from './auth0-variables';

export default class Auth {
  auth0 = new auth0.WebAuth({
    domain: AUTH_CONFIG.domain,
    clientID: AUTH_CONFIG.clientId,
    redirectUri: AUTH_CONFIG.callbackUrl,
    state: AUTH_CONFIG.clientName,
    audience: `skycurrency`,
    responseType: 'token id_token',
    scope: 'openid profile'
  });

  userProfile;

  constructor() {
    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
    this.isSSOAuthenticated = this.isSSOAuthenticated.bind(this);
    this.checkSilentSession = this.checkSilentSession.bind(this);
    this.handleAuthentication = this.handleAuthentication.bind(this);
    this.isAuthenticated = this.isAuthenticated.bind(this);
    this.getAccessToken = this.getAccessToken.bind(this);
    this.getProfile = this.getProfile.bind(this);
  }

  login(options) {
    this.auth0.authorize(options || {});
  }

  handleAuthentication() {

    this.auth0.parseHash((err, authResult) => {
      if (authResult && authResult.accessToken && authResult.idToken) {
        this.setSession(authResult);
        history.replace('/');
      } else if (err) {
        history.replace('/');
        console.log(`Error: ${err.error}. Check the console for further details.`);
      }
    });
  }

  setSession(authResult) {
    // Set the time that the access token will expire at
    let expiresAt = JSON.stringify((authResult.expiresIn * 9999) + new Date().getTime());
    localStorage.setItem('access_token', authResult.accessToken);
    localStorage.setItem('id_token', authResult.idToken);
    localStorage.setItem('expires_at', expiresAt);
    // navigate to the home route
    //history.replace('/');
  }

  getAccessToken() {
    const accessToken = localStorage.getItem('access_token');
    if (!accessToken) {
      throw new Error('No access token found');
    }
    return accessToken;
  }

  getProfile(cb) {
    let accessToken = this.getAccessToken();
    this.auth0.client.userInfo(accessToken, (err, profile) => {
      if (profile) {
        this.userProfile = profile;
      }
      cb(err, profile);
    });
  }



  logout() {
    // Clear access token and ID token from local storage
    localStorage.removeItem('access_token');
    localStorage.removeItem('id_token');
    localStorage.removeItem('expires_at');
    // navigate to the home route
    //history.replace('/');
    this.auth0.logout({
      returnTo: window.location.origin,
      clientID:  AUTH_CONFIG.clientId
    });
  }

  isSSOAuthenticated(tok_nonce = null) {
    // Check whether the current time is past the
    // access token's expiry time
    if (tok_nonce){
      this.auth0.checkSession({}, (err, authResult) => {
        if (authResult && authResult.accessToken && authResult.idToken) {
          this.setSession(authResult);
        } else if (err) {
          // Do NOT log out here. checkSession() runs in a hidden iframe and can
          // fail for environmental reasons (third-party cookie blocking, origin
          // not allow-listed) even though the user's tokens are valid — logging
          // out ejected freshly-logged-in users. The session still expires
          // naturally via isAuthenticated()'s expires_at check.
          console.warn(`[sso-check] checkSession failed: ${err.error}. Keeping current session.`);
        }
      });
    }else{
      console.log('No nonce!');
    }
  }

  // Attempts a silent SSO check via the shared Auth0 session (if one exists at
  // the custom domain from another Skypad app). Unlike isSSOAuthenticated(),
  // this must NOT log the user out on failure — they were never logged in here.
  checkSilentSession(onSuccess, onFailure) {
    this.auth0.checkSession({}, (err, authResult) => {
      if (authResult && authResult.accessToken && authResult.idToken) {
        this.setSession(authResult);
        onSuccess();
      } else {
        onFailure(err);
      }
    });
  }

  isAuthenticated(tok_nonce = null) {
    // Check whether the current time is past the
    // access token's expiry time
    let expiresAt = JSON.parse(localStorage.getItem('expires_at'));
    return new Date().getTime() < expiresAt;

  }
}
